/* @flow */
import * as React from 'react';
import NotificationsReview from '../views/NotificationsReview/NotificationsReview';
import NotificationsContainer from '../views/Notifications/Container';
import SentRequestsReview from '../views/SentRequestsReview/SentRequestsReview';
import { allRoles } from 'permissions/general';

const notifications = [
  {
    path: '/notifications',
    title: 'general:document_titles.notifications.title',
    component: NotificationsContainer,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/notifications/:id',
    title: 'general:document_titles.notifications.detail',
    title_keys: ['notification.contract.company_name', 'notification.event_type'],
    component: NotificationsReview,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/sent-requests/:id',
    title: 'general:document_titles.notifications.sent_request',
    title_keys: ['notification.account_name', 'notification.action_name'],
    component(props) {
      return <SentRequestsReview {...props} notificationType="sentRequest" />;
    },
    exact: true,
    permissions: allRoles,
  },
];

export default notifications.map(item => ({
  ...item,
  store: ['notificationStore'],
}));
